import { render, staticRenderFns } from "./CollectionBackPerformanceForAmount.vue?vue&type=template&id=5283c5bf&scoped=true&"
import script from "./CollectionBackPerformanceForAmount.vue?vue&type=script&lang=js&"
export * from "./CollectionBackPerformanceForAmount.vue?vue&type=script&lang=js&"
import style0 from "./CollectionBackPerformanceForAmount.vue?vue&type=style&index=0&id=5283c5bf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5283c5bf",
  null
  
)

export default component.exports